import { UserProfile } from "@skyportal/auth-web-client";

export const isUserAllowToShowAgreements = (userProfile: UserProfile): boolean => {
  return Boolean(userProfile.is_admin || userProfile.customerErpId);
};
